import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";

export const getAuthHeaders = () => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  if (!user?.token) {
    throw new Error("Authentication token is missing or invalid");
  }
  return {
    Authorization: `Bearer ${user.token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  };
};

export const citysearch = createAsyncThunk(
  "hotel/citysearch",
  async ({ keyword }, { rejectWithValue, signal }) => {
    try {
      const response = await api.get(`/hotel/v1/city_search`, {
        params: { keyword },
        headers: getAuthHeaders(),
        signal,
      });
      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to fetch city search",
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const hotelsearchquery = createAsyncThunk(
  "hotel/hotelsearchquery",
  async (searchParams, { rejectWithValue }) => {
    try {
      const response = await api.post(`/hotel/v1/searchquery`, searchParams, {
        headers: getAuthHeaders(),
      });

      return {
        data: response.data,
        interNationalSearch: searchParams.interNationalSearch,
        routeType: searchParams.JourneyType,
      };
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to fetch hotel search query",
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const fetchhotelresult = createAsyncThunk(
  "hotel/fetchhotelresult",
  async ({ searchId, currency }, { rejectWithValue }) => {
    try {
      const response = await api.post(`/hotel/v1/search-result`, { searchId, currency }, { headers: getAuthHeaders() });

      return {
        searchId,
        data: response.data,
      };
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to fetch hotel results",
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const FetchHotelDetails = createAsyncThunk("hotel/hoteldetails", async ({ FormData }, { rejectWithValue }) => {
  try {
    const response = await api.post(`/hotel/v1/hotel-details`, FormData, { headers: getAuthHeaders() });
    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to validate fare",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});

export const hotelreview = createAsyncThunk("hotel/hotelreview", async ({ FormData }, { rejectWithValue }) => {
  try {
    const response = await api.post(`/hotel/v1/hotel-review`, FormData, { headers: getAuthHeaders() });
    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to validate fare",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});
export const saveitinerary = createAsyncThunk("hotel/saveitinerary", async ({ FormData }, { rejectWithValue }) => {
  try {
    const response = await api.post(`/hotel/v1/saveitinerary`, FormData, { headers: getAuthHeaders() });
    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to validate fare",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});

export const bookingdetails = createAsyncThunk("hotel/bookingdetails", async ({ FormData }, { rejectWithValue }) => {
  try {
    const response = await api.post(`/hotel/v1/bookingdetails`, FormData, { headers: getAuthHeaders() });
    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to validate fare",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});

export const walletbooking = createAsyncThunk("hotel/bookingprocess", async (FormData, { rejectWithValue }) => {
  try {

    const response = await api.post(`/hotel/v1/bookingprocess`, FormData, { headers: getAuthHeaders() });
    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to validate fare",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});
export const fetchbookingcalendar = createAsyncThunk(
  "hotel/bookingcalendar",
  async ({ FilterData, perPage, cursor = null }, { rejectWithValue }) => {
    try {
      let url = `/hotel/v1/bookingcalendar?per_page=${perPage}`;
      if (cursor) {
        url += `&cursor=${encodeURIComponent(cursor)}`;
      }
      const response = await api.post(url, FilterData, { headers: getAuthHeaders() });
      return { data: response.data };
    } catch (error) {
      // if (error.response.data.httpStatus === 401 && error.response.data.message === 'Unauthenticated') {
      //   localStorage.removeItem('user');
      //   window.location.reload();
      // }
      return rejectWithValue({
        message: error?.response?.message || "Failed to validate fare",
        status: error.response?.data?.status,
        data: error.response?.data,
      });
    }
  }
);
const hotelSlice = createSlice({
  name: "hotel",
  initialState: {
    data: null,
    results: null,
    loading: false,
    resultLoading: true,
    ReviewLoading: true,
    DetailsLoading: true,
    error: null,
    interNationalSearch: false,
    routeType: null,
    cityResults: [],
    cityLoading: false,
    cityError: null,
  },
  reducers: {
    clearHotelData: (state) => {
      state.data = null;
      state.results = null;
      state.error = null;
      state.loading = false;
      state.resultLoading = false;
      state.ReviewLoading = false;
      state.DetailsLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(citysearch.pending, (state) => {
        state.cityLoading = true;
        state.cityError = null;
      })
      .addCase(citysearch.fulfilled, (state, action) => {
        state.cityLoading = false;
        state.cityResults = action.payload?.data?.data ?? action.payload?.data ?? [];
      })
      .addCase(citysearch.rejected, (state, action) => {
        state.cityLoading = false;
        if (!action.meta.aborted) {
          state.cityError = action.payload?.message || "Failed to fetch cities";
        }
      })

      .addCase(hotelsearchquery.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(hotelsearchquery.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.interNationalSearch = action.payload.interNationalSearch;
        state.routeType = action.payload.routeType;
      })
      .addCase(hotelsearchquery.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Something went wrong";
      })

      .addCase(fetchhotelresult.pending, (state) => {
        state.resultLoading = true;
        state.error = null;
      })
      .addCase(fetchhotelresult.fulfilled, (state, action) => {
        state.resultLoading = false;
        state.results = action.payload.data;
      })
      .addCase(fetchhotelresult.rejected, (state, action) => {
        state.resultLoading = false;
        state.error = action.payload?.message || "Failed to fetch results";
      })

      .addCase(FetchHotelDetails.pending, (state) => {
        state.resultLoading = true;
        state.error = null;
      })
      .addCase(FetchHotelDetails.fulfilled, (state, action) => {
        state.resultLoading = false;
        state.hoteldata = action.payload.data;
      })
      .addCase(FetchHotelDetails.rejected, (state, action) => {
        state.resultLoading = false;
        state.error = action.payload?.message || "Failed to fetch results";
      })

      .addCase(hotelreview.pending, (state) => {
        state.ReviewLoading = true;
        state.error = null;
      })
      .addCase(hotelreview.fulfilled, (state, action) => {
        state.ReviewLoading = false;
        state.hotelreview = action.payload.data;
      })
      .addCase(hotelreview.rejected, (state, action) => {
        state.ReviewLoading = false;
        state.error = action.payload?.message || "Failed to fetch results";
      })
      .addCase(saveitinerary.pending, (state) => {
        state.resultLoading = true;
        state.error = null;
      })
      .addCase(saveitinerary.fulfilled, (state, action) => {
        state.resultLoading = false;
        state.saveitinerary = action.payload.data;
      })
      .addCase(saveitinerary.rejected, (state, action) => {
        state.resultLoading = false;
        state.error = action.payload?.message || "Failed to fetch results";
      })
      .addCase(bookingdetails.pending, (state) => {
        state.DetailsLoading = true;
        state.error = null;
      })
      .addCase(bookingdetails.fulfilled, (state, action) => {
        state.DetailsLoading = false;
        state.bookingdetails = action.payload.data;
      })
      .addCase(bookingdetails.rejected, (state, action) => {
        state.DetailsLoading = false;
        state.error = action.payload?.message || "Failed to fetch results";
      })
      .addCase(walletbooking.pending, (state) => {
        state.resultLoading = true;
        state.error = null;
      })
      .addCase(walletbooking.fulfilled, (state, action) => {
        state.resultLoading = false;
        state.walletbooking = action.payload.data;
      })
      .addCase(walletbooking.rejected, (state, action) => {
        state.resultLoading = false;
        state.error = action.payload?.message || "Failed to fetch results";
      })
      .addCase(fetchbookingcalendar.pending, (state, action) => {
        state.bookingcalendarStatus = "loading";
      })
      .addCase(fetchbookingcalendar.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.bookingcalendarStatus = data.status.success;
        state.bookingcalendar = data || {};
      });
  },
});

export const { clearHotelData } = hotelSlice.actions;
export const selectCityResults = (state) => state.hotel.cityResults;
export const selectCityLoading = (state) => state.hotel.cityLoading;
export const selectHotelQuery = (state) => state.hotel.data;
export const selectHotelData = (state) => state.hotel.hoteldata;
export const selectresultLoading = (state) => state.hotel.resultLoading;
export const selectReviewLoading = (state) => state.hotel.ReviewLoading;
export const selectDetailsLoading = (state) => state.hotel.DetailsLoading;
export const selectHotelReview = (state) => state.hotel.hotelreview;
export const selectsaveitinerary = (state) => state.hotel.saveitinerary;
export const selectbookingdetails = (state) => state.hotel.bookingdetails;
export const selectwalletbooking = (state) => state.hotel.walletbooking;
export default hotelSlice.reducer;